export const messages = {
  en: {
    auditShopCommunity: {
      title: 'Shop Community Audit',
      communityCode: 'Community Code',
      communityName: 'Community Name',
      shopName: 'Shop Name',
      joinTime: 'Join Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      operation: 'Operation',
      audit: 'Audit'
    },
    audit: {
      status: 'Audit Status',
      statusRequired: 'Please select audit status',
      reason: 'Reason',
      reasonRequired: 'Reason is required',
      reasonMaxLength: 'Reason cannot exceed 200 characters',
      reasonPlaceholder: 'Required, please enter the reason',
      agreeReason: 'Agree'
    },
    common: {
      submit: 'Submit',
      cancel: 'Cancel',
      operateSuccess: 'Operation successful'
    }
  },
  zh: {
    auditShopCommunity: {
      title: '店铺入驻小区',
      communityCode: '小区编码',
      communityName: '小区名称',
      shopName: '商铺名称',
      joinTime: '入驻时间',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态',
      operation: '操作',
      audit: '审核'
    },
    audit: {
      status: '审核状态',
      statusRequired: '请选择审核状态',
      reason: '原因',
      reasonRequired: '原因不能为空',
      reasonMaxLength: '原因不能超过200个字符',
      reasonPlaceholder: '必填，请填写原因',
      agreeReason: '同意'
    },
    common: {
      submit: '提交',
      cancel: '取消',
      operateSuccess: '操作成功'
    }
  }
}